/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2024 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2004 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createReducer } from '@reduxjs/toolkit';
import { IMsgListElement, MsgListAction } from './MsgListActions';

export interface IMsgListState {
  elements: IMsgListElement[];
}

const initialState: IMsgListState = {
  elements: [],
};

const MsgListReducer = createReducer<IMsgListState>(initialState, (builder) => {
  builder.addCase(MsgListAction.Added, (state, action) => {
    return {
      ...state,
      elements: [...state.elements, action.payload],
    };
  });

  builder.addCase(MsgListAction.Delete, (state, action) => {
    return {
      ...state,
      elements: state.elements.filter((e) => e.id !== action.payload),
    };
  });
});

export default MsgListReducer;
